import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface FavoriteLocation {
  id: string
  name: string
  latitude: number
  longitude: number
  country?: string
}

interface FavoritesStore {
  favorites: FavoriteLocation[]
  addFavorite: (location: Omit<FavoriteLocation, 'id'>) => void
  removeFavorite: (id: string) => void
  isFavorite: (lat: number, lon: number) => boolean
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      favorites: [],
      addFavorite: (location) => {
        const id = `${location.latitude},${location.longitude}`;
        const existing = get().favorites.find((f) => f.id === id);
        if (!existing) {
          set((state) => ({
            favorites: [...state.favorites, { ...location, id }],
          }));
        }
      },
      removeFavorite: (id) => {
        set((state) => ({
          favorites: state.favorites.filter((f) => f.id !== id),
        }));
      },
      isFavorite: (lat, lon) => {
        const id = `${lat},${lon}`;
        return get().favorites.some((f) => f.id === id);
      },
    }),
    {
      name: 'favorites-storage',
      version: 1,
      migrate: (persistedState) => persistedState,
    },
  ),
);
